export const SAVE_ANSWERS = "@@SingleTest/SAVE_ANSWERS";

export const actionCreators = {
  saveAnswers: (answers, uid) => ({
    type: SAVE_ANSWERS,
    payload: {
      answers,
      uid,
    },
  }),
};
